
import React from "react";

const SubscriptionSwitchModal = ({
  open,
  currentPlan,
  invitedPlan,
  onConfirm,
  onCancel,
}) => {
  if (!open) return null;
  return (
    <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg p-6 max-w-md w-full shadow-lg">
        <h2 className="text-lg font-semibold mb-2">Switch Subscription?</h2>
        <p className="mb-4">
          You are currently on <b>{currentPlan?.plan?.name || "Free"}</b>.<br />
          You are being invited to join <b>{invitedPlan?.plan?.name || "another plan"}</b>.<br />
          {currentPlan?.plan?.priority < invitedPlan?.plan?.priority
            ? "This will upgrade your subscription."
            : "This will switch your subscription."}
          <br />
          Your current subscription will be cancelled if you continue.
        </p>
        <div className="flex justify-end gap-2">
          <button
            className="px-4 py-2 rounded bg-gray-200 hover:bg-gray-300"
            onClick={onCancel}
          >
            Stay with current plan
          </button>
          <button
            className="px-4 py-2 rounded bg-btn-primary text-white hover:opacity-90"
            onClick={onConfirm}
          >
            Switch & Accept
          </button>
        </div>
      </div>
    </div>
  );
};

export default SubscriptionSwitchModal;